import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PageTitle } from '../../../shared/Typography/PageTitle';
import { GeneralTable } from '../../../shared/Table/GeneralTable';
import { TableLoadingLayout } from '../../../layouts/LoadingLayouts/TableLoadingLayout';
import { Box } from '@mui/material';
import { isNullOrUndefined } from '../../../../utils/utils';
import { ShipmentsData, ShipmentsHeadCellContent } from 'models/Shipments';
import useShipments from 'hooks/shipments/useShipments';
import { SHIPMENTS_HEAD_CELLS } from 'utils/constans/tableHeads/shipmentsTableHead';
import { ShipmentsTableRow } from 'components/shipments/ShipmentsTableRow';

export const Shipments = () => {
    const { t } = useTranslation('shipments', {
        keyPrefix: 'SHIPMENTS',
    });
    const [shipmentsList, setShipmentsList] = useState(null);

    const shipmentsSWR = useShipments();
    const { shipments, isLoading, isError, forceRefresh } =
        shipmentsSWR.useShipmentsSWR();

    useEffect(() => {
        if (!isLoading && isNullOrUndefined(shipmentsList)) {
            setShipmentsList(shipments);
        }
    }, [isLoading, shipments]);

    const tableHeadSettings = {
        translateNs: 'shipments',
        translatePrefix: 'SHIPMENTS.TABLE_HEAD',
        selectable: false,
        headContent: SHIPMENTS_HEAD_CELLS,
    };

    const tableToolbarSettings = {
        translateNs: 'shipments',
        translatePrefix: 'SHIPMENTS.TABLE_TOOLBAR',
    };

    const filterTerm = (search) => {
        return shipmentsList.filter((el) => {
            return (
                el.shipmentNumber.includes(search.toLowerCase()) ||
                el.price_net.toString().includes(search)
            );
        });
    };

    return (
        <>
            <PageTitle>{t('PAGE_TITLE')}</PageTitle>
            {isError && <Box>{t('LOADING_ERROR')}</Box>}
            {isLoading && <TableLoadingLayout />}
            {!isLoading && shipmentsList && (
                <GeneralTable<ShipmentsData, ShipmentsHeadCellContent>
                    fullList={shipmentsList}
                    rowComponent={ShipmentsTableRow}
                    filterTerm={filterTerm}
                    defaultOrderBy={'invoiceDate'}
                    defaultOrder={'desc'}
                    selectHandleId={'number'}
                    tableHeadSettings={tableHeadSettings}
                    tableToolbarSettings={tableToolbarSettings}
                    forceRefresh={forceRefresh}
                    isLoading={isLoading}
                />
            )}
        </>
    );
};
